/**
 * Skeleton — DESIGN.md 4.7, 6.3ב.
 *
 * ⭐ "Skeleton בצורת הפריסה הסופית (כרטיסים אפורים עם shimmer עדין), לא ספינר
 *    עגול במרכז מסך." הרשת עצמה `aria-hidden` (דקורטיבית בלבד) — הודעת הטעינה
 *    האמיתית לקוראי מסך היא `aria-live` נפרד שממשיך להתקיים לצד ה-skeleton
 *    (למשל `<p className="sr-only" aria-live="polite">טוען מוצרים…</p>`).
 * ⛔ shimmer הוא האנימציה האינסופית היחידה שמותרת באתר (6.3) - ורק בזמן טעינה
 *    אמיתית. `prefers-reduced-motion`/`stop-animations` כבר מכבים כל אנימציה
 *    גלובלית ב-`index.css`, כולל את זו.
 */
interface SkeletonCardGridProps {
  count: number;
  className: string;
}

export function SkeletonCardGrid({ count, className }: SkeletonCardGridProps) {
  return (
    <div className={className} aria-hidden="true">
      {Array.from({ length: count }, (_, index) => (
        <div key={index} className="overflow-hidden rounded-lg border border-line">
          <div className="skeleton-shimmer aspect-square" />
          <div className="space-y-2 p-4">
            <div className="skeleton-shimmer h-4 w-3/4 rounded" />
            <div className="skeleton-shimmer h-3 w-1/2 rounded" />
          </div>
        </div>
      ))}
    </div>
  );
}
